// IMPORT PROJECT REFERENCES
import AnalysisViewer from '../AnalysisViewer/AnalysisViewer';
import PropTypes from 'prop-types';
// IMPORT PACKAGE REFERENCES
import React from 'react';

// COMPONENT
export const AnalysisViewerPage = ({ match, location }) => (
    <div className="p-3">
        <AnalysisViewer
            analysisId={match.params.analysisId}
            backLink={location.state ? location.state.backLink : null}
        />
    </div>
);

AnalysisViewerPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
            analysisId: PropTypes.string,
        }),
    }),
    location: PropTypes.shape({
        state: PropTypes.shape({
            backLink: PropTypes.string,
        }),
    }),
};
